import getAcronym from './getAcronym';

const getShortenedName = (firstName: string, lastName: string) =>
    `${firstName ? getAcronym(firstName) : ''} ${lastName ?? ''}`.trim();

export default getShortenedName;
